import React from 'react';
import { Select } from 'antd';
import { useDidMount } from '../../use';
import getUdc from '../../../service/udc';
import { generators } from '../../../utils';

const { Option } = Select;

const AsyncSelect = ({ type, optionDisabled, ...rest }, ref) => {
  const [dataSource, setDataSource] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const fetchData = async () => {
    setLoading(true);
    const response = await getUdc(type);
    if (response.success) {
      const dataSource = generators.generatorArray(response.data);
      setDataSource(dataSource);
      setLoading(false);
    }
  };
  useDidMount(() => fetchData());

  return (
    <Select {...rest} loading={loading} ref={ref}>
      {dataSource.map((item, index) => (
        <Option key={index} value={item.code} disabled={item.code === '14' && optionDisabled}>
          {item.name}
        </Option>
      ))}
    </Select>
  );
};

export default React.forwardRef(AsyncSelect);
